import React, { Component } from "react";
import config from "react-global-configuration";
import RequestApi from "../Miscelania/RequestApi";

// Helpers de formulário
import InputMask from "react-input-mask";
import Select from "react-select";

import { Link, Redirect } from "react-router-dom";
import Topo from "../Layout/Topo";
import Overlay from "../Miscelania/Overlay";

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

class PlanningsAddVacations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: "",
        type: "",
        status: "closed",
      },
      redirect_url: false,
      loaded: 0,
      year: null,
      name: "",
      years: [
        { value: "2020", label: "2020" },
        { value: "2021", label: "2021" },
        { value: "2022", label: "2022" },
        { value: "2023", label: "2023" },
        { value: "2024", label: "2024" },
        { value: "2025", label: "2025" },
        { value: "2026", label: "2026" },
        { value: "2027", label: "2027" },
        { value: "2028", label: "2028" },
        { value: "2029", label: "2029" },
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if (mode === "reset") {
      this.setState({ overlay: { message: "", type: "", status: "closed" } });
    } else {
      this.setState({
        overlay: { message: message, type: type, status: status },
      });
    }
  }

  handleLoaded(state) {
    if (this.state.loaded !== 2) {
      this.setState({ loaded: state });
    }
  }

  handleMessage() {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== "undefined") {
      message = JSON.parse(message);
      var self = this;
      self.setState({
        overlay: {
          message: message.alert_message,
          type: message.alert_type,
          status: "open",
        },
      });
      localStorage.removeItem("verify_message");
    }
  }

  // Handlers
  handleChange(name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if (event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  componentDidMount() {
    this.refs.request_api.header();
  }

  add(event) {
    event.preventDefault();
    this.handleAlert("", "", "open");
    var datasave = {
      name: this.state.name,
      year: this.state.year,
    };
    var self = this;
    var header = this.refs.request_api.header("application/json");
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/planejamento/ferias", {
        method: "POST",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          if (responseJson.status === "success") {
            var url = "/planejamento/ferias/" + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status,
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  render() {
    return (
      <div>
        <Topo></Topo>
        <RequestApi ref={"request_api"} handleLoaded={this.handleLoaded} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        {this.state.redirect_url ? (
          <Redirect to={{ pathname: this.state.redirect_url }} />
        ) : (
          ""
        )}
        <div className="container">
          <div className="conteudo">
            <h3 className="page-title pull-left">
              Cadastrar planejamento de férias
            </h3>
            <div className="clearfix"></div>
            <hr />
            <form onSubmit={this.add}>
              <div className="row">
                <div className="col-md-6 form-group">
                  <label>Identificação (opcional):</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={this.state.name}
                    placeholder=""
                    onChange={this.handleChange.bind(this, "name")}
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label>Ano:</label>
                  <Select
                    className="form-field-name"
                    name="year"
                    value={this.state.year}
                    searchable={true}
                    placeholder={"Selecionar ano"}
                    onChange={this.handleSelectChange.bind(this, "year")}
                    options={this.state.years}
                  />
                </div>
              </div>
              <hr />
              <button
                type={"submit"}
                className="btn btn-success btn-lg btn-block"
              >
                <i className="fa fa-fw fa-save"></i> Criar planejamento de
                férias
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default PlanningsAddVacations;



// WEBPACK FOOTER //
// ./src/Components/Plannings/PlanningsAddVacations.js